import React, { useEffect } from 'react';
import './HomePage.scss';
import Section1 from '../HomePageSections/Section1/Section1.js';
import Section2 from '../HomePageSections/Section2/Section2.js';
import Section3 from '../HomePageSections/Section3/Section3.js';
import CommonInsuranceSection from '../HomePageSections/CommonInsuranceSection/CommonInsuranceSection.js';
import FooterSection from '../HomePageSections/FooterSection/FooterSection.js';
const HomePage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);

    return (
        <div className="home-page-container">
            <Section1 />
            <Section2 />
            <Section3 />
            <CommonInsuranceSection />
            <FooterSection />
        </div>
    );
};

export default HomePage;
